const setUpMixins = (Vue, vuetify) => {
  Vue.mixin({
    computed: {
      $smallScreen () {
        return vuetify.smAndDown
      }
    }
  })
}

export default setUpMixins
